import React, {Component} from 'react'
import {Button, Icon, Modal, Form, Popup} from 'semantic-ui-react'
import {saveMessage} from './save-message'

class ChatButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      message: '',
      messages: []
    }
  }

  openModal = () => this.setState({open: true})
  closeModal = () => this.setState({open: false})

  sendMessage = () => {
    let {message, messages} = this.state
    messages.push({textAlign: 'right', text: message})
    this.setState({message: '', messages})
    saveMessage(message, (err, res) => {
      if (err) {
        alert('There was an error when trying to ask anything.')
      } else {
        this.saveMessageSuccess(res)
      }
    })
  }

  saveMessageSuccess = (res) => {
    let {messages} = this.state
    messages.push({textAlign: 'left', text: res.data.text})
    this.setState({messages})
  }

  fieldOnChange = (event, {value, name}) => {
    let newState = {}
    newState[name] = value
    this.setState(newState)
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.sendMessage()
    }
  }

  render() {
    let {open, message, messages} = this.state

    return (
      <div>
        <Modal onClose={this.closeModal} open={open} closeIcon>
          <Modal.Header>
            Chat
          </Modal.Header>
          <Modal.Content style={{minHeight: '200px'}}>
            {messages.map(x => <div style={{textAlign: x.textAlign}}>{x.text}</div>)}
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.sendMessage} style={{float: 'right', marginLeft: '20px'}}>Send</Button>

            <Form.Input
              placeholder='Ask Anything' fluid onKeyDown={this.handleKeyDown} onChange={this.fieldOnChange} name='message' value={message}
              autoComplete="off"
            />
          </Modal.Actions>
        </Modal>
        <Popup content='Talk to AI' position='right center'
          trigger={
            <Button icon basic onClick={this.openModal} style={{position: 'fixed',top: '16px', right: '100px', zIndex: 9999}}>
              <Icon name='chat' />
            </Button>
          }
        />

      </div>
    )
  }
}

export default ChatButton
